const PictViewClass = require('pict-view');

/** @typedef {import('./HeadlightPanels-View.js').Pict} Pict */

class DocumentDetails extends PictViewClass
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;

		this.ActiveDocumentDetails = {};
	}

	/**
	 * This method resets the state of the Document Details view to a default state.
	 */
	resetDocumentDetailsView()
	{
		this.ActiveDocumentDetails = {};
	}

	/**
	 * Open the Document detail view for the selected Document to view the full details
	 * @param {object} event - The click event
	 * @param {number|string} pIDDocument - The ID of the Document to view
	 * @param {string} [pDocumentRecord] - The record of the Document to view (optional)
	 */
	showDocumentDetailView(event, pIDDocument, pDocumentRecord)
	{
		// check the document data first to make sure it's not already loaded
		this.pict.views.DocumentDetails.ActiveDocumentDetails = this.pict.AppData?.DocumentData?.ReportData?.IDDocument === pIDDocument ? this.pict.AppData.DocumentData.ReportData : null;
		// if not found, try the search results next
		if (!this.pict.views.DocumentDetails.ActiveDocumentDetails)
		{
			this.pict.views.DocumentDetails.ActiveDocumentDetails = pDocumentRecord || this.pict.views.DocumentSearch.CurrentSearchResults.find((obs) => obs.IDDocument == pIDDocument);
		}
		// open the panel if it is not already open
		this.pict.views.HeadlightPanels.handlePanelToggle('DocumentDetails', 'open');
		// render the Document detail view
		this.pict.views.DocumentDetails.renderAsync(false, false, false, false, () =>
		{
			this.log.info('Document Details View Rendered with Active Record', this.pict.views.DocumentDetails.ActiveDocumentDetails);
		});
	}

	/**
	 * Confirmation Modal to open a form in the webApp
	 */
	confirmOpenForm(pIDDocument, windowTarget)
	{
		// footer templates for the confirmation modal
		const confirmModalFooterTemplate = /*html*/`
		<div id="ConfirmModalFooter" class="buttons is-right">
			<button class="button is-link is-soft" type="button" title="Cancel Open" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-primary" type="button" title="Open Document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, ${pIDDocument}, '${windowTarget}'); _Pict.fable.services.HeadlightModal.dismissModals();">
				<span class="icon">
					<i class="fas fa-fw fa-check" aria-hidden="true"></i>
				</span>
				<span>Continue</span>
			</button>
		</div>`;
		// the options for the confirmation modal
		const confirmModalOptions = {
			title: 'Open Document?',
			message: 'Are you sure you want to open this document? This will replace the current document.',
			modalFooterTemplate: confirmModalFooterTemplate,
		};
		this.fable.HeadlightModal.spawnModal(confirmModalOptions, this.pict.providers.DocumentProvider.openFormByIDDocument.bind(this));
	}

	// the callback to run when the user confirms the duplication
	confirmDuplicateCallback(event)
	{
		if (event)
		{
			event.target.classList.add('is-loading');
		}
		// the custom options for the duplication
		const customOptions = {};
		const originalTitle = this.ActiveDocumentDetails.Name;
		// fetch the custom title for the duplicated document
		const newDocumentTitle = this.pict.ContentAssignment.readContent('#DUPLICATE-FOR-DocumentDetails-Document-Header-Title');
		// set the new document title in case it was changed
		customOptions.Name = newDocumentTitle;
		const newDocumentDate = this.pict.ContentAssignment.readContent('#DUPLICATE-FOR-DocumentDetails-Document-Header-Date');
		const currentTime = this.pict.providers.DocumentProvider.getDocumentDateCurrentTime();
		customOptions.DocumentDate = newDocumentDate ? this.fable.Dates.dayJS(newDocumentDate + currentTime).toISOString() : this.fable.Dates.dayJS(new Date()).toISOString();

		//set window Target based on call from mobile device or desktop
		const windowTarget = this.pict.providers.DocumentProvider.isOpenDocumentCalledFromMobileDevice() ? '_top' : '_blank';
		// duplicate the document
		this.pict.providers.DocumentProvider.handleDocumentDuplication(customOptions, this.ActiveDocumentDetails, (pNewDocument) =>
		{
			if (event)
			{
				event.target.classList.remove('is-loading');
			}
			// custom body content
			document.getElementById('DuplicateDocumentModalBody').innerHTML =
			/*html*/`
			<div class="container column is-12">
				<p class="title is-5 has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-circle-check has-text-success"></i>
					</span>
					<span> Document successfully duplicated.</span>
				</p>
				<p class="subtitle is-6 has-text-centered">A new document titled <strong>${ newDocumentTitle }</strong> has been created with all previously saved data from the original <strong>${ originalTitle }</strong> document.</p>
				<p class="subtitle is-6 has-text-centered">Please click button below to open your new document or close this modal.</p>
			</div>`;
			// custom footer content
			document.getElementById('DuplicateDocumentModalFooter').innerHTML =
			/*html*/`
			<button class="button is-link is-soft" type="button" title="Close modal" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Close</span>
			</button>
			<button class="button is-link" type="button" title="Open new document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocument(event, '${ pNewDocument?.IDDocument }', '${windowTarget}'); _Pict.fable.services.HeadlightModal.dismissModals();">
				<span class="icon">
					<i class="fas fa-fw fa-external-link-alt" aria-hidden="true"></i>
				</span>
				<span>Open New Document</span>
			</button>`;
		});
	};

	handleDeleteActiveForm()
	{
		// prompt a confirmation modal to do the deletion
		this.fable.HeadlightModal.spawnModal({
			title: 'Delete Document',
			modalBodyTemplate: /*html*/`
			<div class="container column is-12">
				<p class="title is-5
				has-text-centered p-2 mb-5">
					<span class="icon">
						<i class="fa fa-fw fa-exclamation-triangle has-text-danger"></i>
					</span>
					<span> Are you sure you want to delete this document?</span>
				</p>
				<p class="is-6 has-text-centered">This action is irreversible and will permanently delete</p>
				<p class="has-text-centered m-3"><strong>${ this.ActiveDocumentDetails.Name }</strong></p>
				<p class="is-6 has-text-centered">Please click button below to confirm deletion or close this modal.</p>
			</div>`,
			modalFooterTemplate: /*html*/`
			<div class="buttons is-right">
				<button class="button is-danger is-soft" type="button" title="Cancel Deletion" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
					<span class="icon">
						<i class="fas fa-fw fa-times" aria-hidden="true"></i>
					</span>
					<span>Cancel</span>
				</button>
				<button class="button is-danger" type="button" title="Delete Document" onclick="_Pict.views.DocumentDetails.onDeleteConfirm()">
					<span class="icon">
						<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
					</span>
					<span>Delete Document</span>
				</button>
			</div>`,
			confirmText: 'Delete Document',
			cancelText: 'Cancel',
		});
	}

	/**
	 * Handle the deletion of the active Document after confirmation
	 */
	onDeleteConfirm()
	{
		this.pict.providers.DocumentProvider.handleDocumentDeletion(this.ActiveDocumentDetails.IDDocument, (pResponse) =>
		{
			this.fable.services.HeadlightModal.dismissModals();
			// show a success toast
			this.pict.views.HeadlightPanels.toast({
				message: 'Document deleted successfully.',
				type: 'is-success',
			});
			this.resetDocumentDetailsView();
			// close the panel
			this.fable.views.HeadlightPanels.handlePanelToggle('DocumentDetails', 'close');
		});
	}

	/**
	 * Duplicate the Form for the selected Document
	 */
	duplicateActiveForm()
	{
		// the body and footer templates for the duplication modal
		const duplicateModalBodyTemplate = /*html*/`
		<span id="DuplicateDocumentModalBody">
			<div class="column is-12">
				<div class="field">
					<label class="label">Document Title</label>
					<div class="control">
						<input id="DUPLICATE-FOR-DocumentDetails-Document-Header-Title" class="input" type="text" placeholder="Document Title" value="${this.ActiveDocumentDetails.Name} (Copy)">
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">Document Type</label>
					<div class="control">
						<input id="DUPLICATE-FOR-DocumentDetails-Document-Header-Type" disabled class="input" type="text" placeholder="Document Type" value="${this.ActiveDocumentDetails.TidingsData.Type}">
					</div>
				</div>
			</div>
			<div class="column is-12">
				<div class="field">
					<label class="label">Document Date</label>
					<div class="control">
						<input 
							id="DUPLICATE-FOR-DocumentDetails-Document-Header-Date" 
							class="input flatpickr-input active" 
							type="date" 
							placeholder="Enter the date of the Document" 
						/>
					</div>
				</div>
			</div>
		</span>`;
		const duplicateModalFooterTemplate = /*html*/`
		<div id="DuplicateDocumentModalFooter" class="buttons is-right">
			<button class="button is-link is-soft" type="button" title="Cancel Duplication" onclick="_Pict.fable.services.HeadlightModal.dismissModals()">
				<span class="icon">
					<i class="fas fa-fw fa-times" aria-hidden="true"></i>
				</span>
				<span>Cancel</span>
			</button>
			<button class="button is-link" type="button" title="Duplicate Document" onclick="_Pict.views.DocumentDetails.confirmDuplicateCallback(event)">
				<span class="icon">
					<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
				</span>
				<span>Duplicate Document</span>
			</button>
		</div>`;
		// the options for the duplication modal
		const duplicationModalOptions = {
			title: 'Duplicate Document',
			modalBodyTemplate: duplicateModalBodyTemplate,
			modalFooterTemplate: duplicateModalFooterTemplate,
			confirmText: 'Create Duplicate',
			cancelText: 'Cancel',
		};
		this.fable.HeadlightModal.spawnModal(duplicationModalOptions, this.confirmDuplicateCallback.bind(this));
	}

	async onBeforeRenderAsync(pCallback)
	{
		if (this.ActiveDocumentDetails && !this.ActiveDocumentDetails?.TidingsData?.Type)
		{
			const customerRNIs = await this.pict.providers.DocumentProvider.getReportNamedInstancesByCustomer(this.ActiveDocumentDetails?.IDCustomer);
			// find the matching document type via the project RNIs
			const match = customerRNIs.find((rni) => rni.Hash === this.ActiveDocumentDetails?.DocumentType);
			if (!match)
			{
				this.pict.log.warn('No matching RNI Hash has been set on this customer!');
			}
			this.ActiveDocumentDetails.TidingsData = match?.Options?.TidingsData;
		}
		pCallback();
	}

	/**
	 * Download the PDF for the selected Document
	 * @param {object} event - The click event
	 */
	handleDocumentDownload(event)
	{
		if (event && event.target instanceof HTMLElement)
		{
			const element = event.target;
			// set the button to be loading
			element.classList.add('is-loading');

			// download the pdf
			this.pict.providers.DocumentProvider.handleDocumentDownload(false, this.ActiveDocumentDetails, () =>
			{
				element.classList.remove('is-loading');
			});
		}
	}
}

module.exports = DocumentDetails;

module.exports.default_configuration =
{
	ViewIdentifier: 'DocumentDetails',
	DefaultRenderable: 'DocumentDetails',
	DefaultDestinationAddress: '#HeadlightPanels-LeftPanel',
	Templates:
	[
		{
			Hash: 'DocumentDetails-Wrapper',
			Template: /*html*/`
			<article id="HeadlightPanels-DocumentDetailsPanel" class="panel is-active">
				<p id="HeadlightPanels-DocumentDetailsPanel-Document-Header" class="panel-heading pr-4">
					<button type="button" class="is-pulled-right hl-panel-close-button" aria-label="close" title="Close panel" onclick="_Pict.views.HeadlightPanels.closeThisPanel(event);_Pict.views.DocumentDetails.resetDocumentDetailsView()">
						<span class="icon">
							<i class="fas fa-fw fa-times-circle" aria-hidden="true"></i>
						</span>
					</button>
					<button type="button" class="is-pulled-right hl-panel-pin-button mr-2" aria-label="pin" title="Pin content" onclick="_Pict.views.HeadlightPanels.togglePanelPinState()">
						<span class="icon">
							<i class="fas fa-fw fa-thumbtack" aria-hidden="true"></i>
						</span>
					</button>
					<span class="icon">
						<i id="HeadlightPanels-DocumentDetailsPanel-Document-Header-Icon" class="fas fa-fw fa-files" aria-hidden="true"></i>
					</span>
					<span id="HeadlightPanels-DocumentDetailsPanel-Document-Header-Title" class="mr-3">Document Details</span>
				</p>
				<div id="HeadlightPanels-DocumentDetails-Content" class="container panel-content"  style="min-width: 33vw;">
					{~T:DocumentDetails-Content:Context[0].ActiveDocumentDetails~}
				</div>
			</div>`,
		},
		{
			Hash: 'DocumentDetails-Content',
			Template: /*html*/`
			<div class="columns px-4 py-2 m-0 has-background-text-20">
					<div class="column">
						<p class="title is-4 has-text-white">{~D:Record.Name~}</p>
						<p class="subtitle is-6 has-text-text-65">
							<span class="is-pulled-right">
								{~TIfAbs:DocumentDetails-Locked:Record.Locked:Record.Locked^==^1~}
								{~TIfAbs:DocumentDetails-Unlocked:Record.Locked:Record.Locked^==^0~}
							</span>
							<span class="mr-1">#{~D:Record.IDDocument~}</span>
							<span class="mr-1 is-size-7">Form #{~D:Record.SequenceNumber~}</span>
						</p>
					</div>
				</div>
				<div class="columns px-5 mt-3">
					<div class="column is-12">
						<span class="title is-block is-6 has-text-text-60">Project</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:Project^Record.IDProject^DocumentDetails-Content-Project^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Created by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.CreatingIDUser^DocumentDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Document Date</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.DocumentDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update by</span>
						<span class="subtitle is-6 has-text-text-90">{~Entity:User^Record.UpdatingIDUser^DocumentDetails-Content-User^~}</span>
					</div>
					<div class="column is-6">
						<span class="title is-block is-6 has-text-text-60">Last Update on</span>
						<span class="subtitle is-6 has-text-text-90">{~DateFormat:Record.UpdateDate^MMMM DD, YYYY - hh:mm a^~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Document Type</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.TidingsData.Type~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Timezone</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Timezone~}</span>
					</div>
				</div>
				<div class="columns px-5">
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Status</span>
						<span class="subtitle is-6 has-text-text-90">{~DocumentState:Record~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Observations</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Observations.length~}</span>
					</div>
					<div class="column">
						<span class="title is-block is-6 has-text-text-60">Work Shift</span>
						<span class="subtitle is-6 has-text-text-90">{~D:Record.Shift~}</span>
					</div>
				</div>
				<div class="buttons is-right py-2 px-5">
					<button class="button is-primary is-dark {~Show:Record.Form~}" type="button" title="Delete document" onclick="_Pict.views.DocumentDetails.handleDeleteActiveForm()">
						<span class="icon">
							<i class="fas fa-fw fa-trash" aria-hidden="true"></i>
						</span>
						<span>Delete</span>
					</button>
					<button class="button is-primary {~Show:Record.Form~}" type="button" title="Duplicate document" onclick="_Pict.views.DocumentDetails.duplicateActiveForm()">
						<span class="icon">
							<i class="fas fa-fw fa-copy" aria-hidden="true"></i>
						</span>
						<span>Duplicate</span>
					</button>
					<button class="button is-primary {~Show:Record.Form~}" type="button" title="Open document" onclick="_Pict.providers.DocumentProvider.openFormByIDDocumentHandler(event, {~D:Record.IDDocument~})">
						<span class="icon">
							<i class="fas fa-fw fa-external-link-alt" aria-hidden="true"></i>
						</span>
						<span>Open</span>
					</button>
					<button class="button is-primary" type="button" title="Download document PDF" onclick="_Pict.views.DocumentDetails.handleDocumentDownload(event)">
						<span class="icon">
							<i class="fas fa-fw fa-file-pdf" aria-hidden="true"></i>
						</span>
						<span>Download PDF</span>
					</button>
				</div>`,
		},
		{
			Hash: 'DocumentDetails-Content-User',
			Template: /*html*/`{~D:Record.NameFirst~} {~D:Record.NameLast~}`,
		},
		{
			Hash: 'DocumentDetails-Content-Project',
			Template: /*html*/`{~D:Record.Name~}`,
		},
		{
			Hash: 'DocumentDetails-Locked',
			Template: /*html*/`
				<span class="icon has-text-text-95">
					<i class="fas fa-fw fa-sm fa-lock"></i>
				</span>
				<span class="icon-text has-text-text-95">Locked</span>`,
		},
		{
			Hash: 'DocumentDetails-Unlocked',
			Template: /*html*/`
				<span class="icon">
					<i class="fas fa-fw fa-sm fa-unlock"></i>
				</span>
				<span class="icon-text">Unlocked</span>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'DocumentDetails',
			TemplateHash: 'DocumentDetails-Wrapper',
			DestinationAddress: '#HeadlightPanels-LeftPanel',
			RenderType: 'replace',
		},
		{
			RenderableHash: 'DocumentDetails-Content',
			TemplateHash: 'DocumentDetails-Content',
			DestinationAddress: '#HeadlightPanels-DocumentDetails-Content',
			RenderType: 'replace',
		},
	],
};
